import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, message, Select, Switch, Tag, Timeline, Input, Modal, DatePicker, Dropdown, Menu, Empty, Button } from "antd";
import { AlertOutlined, ToolOutlined, DownOutlined, SendOutlined, CheckSquareOutlined, MailOutlined } from "@ant-design/icons";
import moment from "moment";
import { FormItem, InputItem, SelectItem, TextAreaItem, DynamicCardForm, ButtonItem, SelectEmpleadosItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ModalFormCMMS from "../componentes/ModalFormCMMS";
import SelectActivoCMMS from "../componentes/SelectActivoCMMS";
import SelectorColoresCMMS, { COLORES_PRIORIDAD } from "../componentes/SelectorColoresCMMS";
import AnexosCMMS from "../componentes/AnexosCMMS";
import { cmmsPost, ESTATUS_TICKET, estatusTicket, estatusServicio, formatoFechaHora, anexosAPayload } from "../cmmsComun";

const { Option } = Select;

// Alta / edicion de un Ticket (solicitud o reporte de falla).
// props: visible, ticketId (editar), activoIdInicial (abrir desde la ficha), onClose(huboCambio)
class ModalTicket extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        ticket: null,
        sinActivo: false,
        tiposSolicitud: [],
        avisarSolicitante: true,
        comentario: "",
        cambioEstatus: null, // { estatus, comentario }
        huboCambio: false,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) this.inicializar();
    }

    get editar() {
        return !!this.props.ticketId;
    }

    inicializar = async () => {
        this.formRef.current?.resetFields();
        this.setState({ loading: true, ticket: null, sinActivo: false, comentario: "", huboCambio: false });
        try {
            const resConfig = await cmmsPost(this.props, "datosConfiguracionCMMS");
            const config = resConfig.data.success === 2 ? resConfig.data.configuracion : {};
            this.setState({ tiposSolicitud: config.tiposSolicitud || [], avisarSolicitante: config.avisosTicket?.avisarSolicitante !== false });
            if (this.editar) await this.consultar();
            else
                this.formRef.current?.setFieldsValue({
                    activoId: this.props.activoIdInicial || undefined,
                    tipoSolicitud: "Falla",
                    prioridad: 2,
                    fechaSolicitud: moment(),
                    anexos: [],
                });
        } finally {
            this.setState({ loading: false });
        }
    };

    consultar = async () => {
        const res = await cmmsPost(this.props, "datosTicketCMMS", { id: this.props.ticketId });
        if (res.data.success !== 2) return message.error(res.data.message || "No se encontró el ticket");
        const t = res.data.ticket;
        this.setState({ ticket: t, sinActivo: !!t.sinActivo });
        this.formRef.current?.setFieldsValue({
            ...t,
            activoId: t.activoId || undefined,
            clienteId: t.clienteId || undefined,
            empleadoAsignadoId: t.empleadoAsignadoId || undefined,
            fechaSolicitud: t.fechaSolicitud ? moment(t.fechaSolicitud) : undefined,
        });
    };

    onFinish = async (values) => {
        this.setState({ loading: true });
        try {
            const payload = {
                ...values,
                id: this.props.ticketId,
                sinActivo: this.state.sinActivo,
                activoId: this.state.sinActivo ? null : values.activoId || null,
                clienteId: values.clienteId || null,
                empleadoAsignadoId: values.empleadoAsignadoId || null,
                fechaSolicitud: values.fechaSolicitud ? moment(values.fechaSolicitud).toISOString() : null,
                anexos: await anexosAPayload(values.anexos),
            };
            const res = await cmmsPost(this.props, this.editar ? "editarTicketCMMS" : "agregarTicketCMMS", payload);
            if (res.data.success === 2) {
                message.success(this.editar ? "Ticket actualizado" : `Ticket ${res.data.folio} registrado`);
                this.props.onClose(true);
            } else message.error(res.data.message || "No se pudo guardar el ticket");
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar el ticket");
        } finally {
            this.setState({ loading: false });
        }
    };

    comentar = async () => {
        const texto = this.state.comentario.trim();
        if (!texto) return;
        const res = await cmmsPost(this.props, "comentarTicketCMMS", { id: this.props.ticketId, texto });
        if (res.data.success === 2) {
            this.setState({ comentario: "", huboCambio: true });
            this.consultar();
        } else message.error(res.data.message || "No se pudo agregar el comentario");
    };

    cambiarEstatus = async () => {
        const { estatus, comentario } = this.state.cambioEstatus || {};
        if (estatus === 6 && !String(comentario || "").trim() && !(this.state.ticket?.servicios || []).length)
            return message.error("Escriba cómo se resolvió el ticket");
        const res = await cmmsPost(this.props, "cambiarEstatusTicketCMMS", { id: this.props.ticketId, estatus, comentario });
        if (res.data.success === 2) {
            message.success(`Ticket ${estatusTicket(estatus).label.toLowerCase()}`);
            this.setState({ cambioEstatus: null, huboCambio: true });
            this.consultar();
        } else message.error(res.data.message || "No se pudo cambiar el estatus");
    };

    crearServicio = () => {
        this.props.onClose(this.state.huboCambio);
        this.props.history.push("/panel/cmmsServicio", { ticketId: this.props.ticketId });
    };

    renderSeguimiento() {
        const t = this.state.ticket;
        if (!t) return null;
        const est = estatusTicket(t.estatus);
        return (
            <>
                <DynamicCardForm
                    title="Seguimiento"
                    xs={24}
                    lg={12}
                    headerRight={
                        <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
                            <Tag color={est.color}>{est.label}</Tag>
                            {![0, 6].includes(t.estatus) && (
                                <ButtonItem verde size="small" htmlType="button" lessTime icon={<CheckSquareOutlined />} onClick={() => this.setState({ cambioEstatus: { estatus: 6, comentario: "" } })}>
                                    Cerrar ticket
                                </ButtonItem>
                            )}
                            {t.estatus !== 0 && (
                                <Dropdown
                                    trigger={["click"]}
                                    overlay={
                                        <Menu onClick={({ key }) => this.setState({ cambioEstatus: { estatus: Number(key), comentario: "" } })}>
                                            {ESTATUS_TICKET.filter((e) => e.value !== t.estatus).map((e) => (
                                                <Menu.Item key={e.value}>{e.label}</Menu.Item>
                                            ))}
                                        </Menu>
                                    }
                                >
                                    <ButtonItem type="default" size="small" htmlType="button">
                                        Cambiar estatus <DownOutlined />
                                    </ButtonItem>
                                </Dropdown>
                            )}
                        </span>
                    }
                >
                    {t.resolucion && (
                        <div className="cmms-banda" style={{ marginBottom: 8 }}>
                            <div>
                                <b>Resolución</b>
                                <div style={{ whiteSpace: "pre-wrap" }}>{t.resolucion}</div>
                            </div>
                        </div>
                    )}
                    <Timeline style={{ marginTop: 6 }}>
                        {(t.historialEstatus || []).map((h, i) => (
                            <Timeline.Item key={i} color={estatusTicket(h.estatus).color === "default" ? "gray" : estatusTicket(h.estatus).color}>
                                <b>{h.estatusNombre}</b> · <span style={{ color: "#7a8794" }}>{formatoFechaHora(h.fecha)} · {h.usuarioNombre || (t.origen === 4 ? "Desde el QR" : "")}</span>
                                {h.comentario ? <div style={{ fontSize: 12 }}>{h.comentario}</div> : null}
                            </Timeline.Item>
                        ))}
                    </Timeline>
                    <h4 style={{ marginBottom: 6 }}>Servicios</h4>
                    {(t.servicios || []).length ? (
                        t.servicios.map((s) => (
                            <div key={s._id} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}>
                                <Button
                                    type="link"
                                    size="small"
                                    style={{ padding: 0, height: "auto" }}
                                    onClick={() => {
                                        this.props.onClose(this.state.huboCambio);
                                        this.props.history.push("/panel/cmmsServicio", { id: s._id });
                                    }}
                                >
                                    {s.codigo} · {s.tipoServicioNombre}
                                </Button>
                                <Tag color={estatusServicio(s.estatus).color}>{s.estatusNombre}</Tag>
                            </div>
                        ))
                    ) : (
                        <div className="cmms-ayuda">Aún no hay servicios para este ticket.</div>
                    )}
                    {t.estatus !== 0 && (
                        <ButtonItem type="primary" htmlType="button" icon={<ToolOutlined />} style={{ marginTop: 10 }} onClick={this.crearServicio}>
                            Crear servicio desde este ticket
                        </ButtonItem>
                    )}
                </DynamicCardForm>
                <DynamicCardForm title={`Comentarios (${(t.comentarios || []).length})`} xs={24} lg={12}>
                    <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                        <Input.TextArea rows={2} value={this.state.comentario} placeholder="Escriba un comentario" onChange={(e) => this.setState({ comentario: e.target.value })} />
                        <ButtonItem type="primary" htmlType="button" icon={<SendOutlined />} disabled={!this.state.comentario.trim()} onClick={this.comentar} />
                    </div>
                    {(t.comentarios || []).length ? (
                        [...t.comentarios].reverse().map((c) => (
                            <div key={c._id} style={{ padding: "6px 0", borderBottom: "1px solid #f0f0f0" }}>
                                <div style={{ fontSize: 11, color: "#7a8794" }}>
                                    {formatoFechaHora(c.fecha)} · {c.usuarioNombre}
                                </div>
                                <div style={{ whiteSpace: "pre-wrap" }}>{c.texto}</div>
                            </div>
                        ))
                    ) : (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin comentarios" />
                    )}
                </DynamicCardForm>
            </>
        );
    }

    // Cambio de estatus. Cerrar sin Orden de Servicio pide como se resolvio (queda en el ticket
    // y se le manda al solicitante).
    renderModalEstatus() {
        const t = this.state.ticket;
        const cambio = this.state.cambioEstatus;
        const estatus = cambio?.estatus;
        const cerrar = estatus === 6;
        const sinServicios = !(t?.servicios || []).length;
        const placeholder =
            estatus === 0
                ? "Motivo de la cancelación (obligatorio)"
                : cerrar
                ? `¿Cómo se resolvió? ${sinServicios ? "(obligatorio)" : "(opcional)"} Ej. Se resolvió por teléfono: el equipo estaba desconectado.`
                : "Comentario (opcional)";
        return (
            <Modal
                visible={!!cambio}
                title={cerrar ? "Cerrar ticket" : `Cambiar a “${estatusTicket(estatus).label}”`}
                onCancel={() => this.setState({ cambioEstatus: null })}
                onOk={this.cambiarEstatus}
                okText={cerrar ? "Cerrar ticket" : "Cambiar"}
                cancelText="Regresar"
            >
                {cerrar && sinServicios && <div className="cmms-ayuda">El ticket no tiene Orden de Servicio: se cierra con la resolución que escriba.</div>}
                <Input.TextArea rows={3} placeholder={placeholder} value={cambio?.comentario} onChange={(e) => this.setState({ cambioEstatus: { ...cambio, comentario: e.target.value } })} />
                {t?.correo && this.state.avisarSolicitante && (
                    <div style={{ fontSize: 12, color: "#7a8794", marginTop: 6 }}>
                        <MailOutlined /> Se le avisará por correo a {t.solicitante || "quien levantó el ticket"} ({t.correo}){estatus === 0 || cerrar ? ", con lo que escriba aquí" : ""}.
                    </div>
                )}
            </Modal>
        );
    }

    render() {
        const t = this.state.ticket;
        return (
            <>
                <ModalFormCMMS
                    titulo={this.editar ? `Ticket ${t?.codigo || ""}` : "Nuevo ticket"}
                    subtitulo={this.editar ? (t?.origen === 4 ? "Reportado por el hospital desde el QR del equipo" : "Solicitud de servicio") : "Registre una solicitud o un reporte de falla."}
                    icono={<AlertOutlined style={{ fontSize: 20, color: "#e8572a" }} />}
                    visible={this.props.visible}
                    loading={this.state.loading}
                    onCancel={() => this.props.onClose(this.state.huboCambio)}
                    formRef={this.formRef}
                    name="ticketCMMS"
                    onFinish={this.onFinish}
                    textoGuardar={this.editar ? "Guardar cambios" : "Registrar ticket"}
                    width={1000}
                >
                    <DynamicCardForm title="Solicitud" xs={24} lg={14}>
                        <FormItem label="Equipo" required={!this.state.sinActivo}>
                            <FormItem name="activoId" noStyle rules={this.state.sinActivo ? [] : [{ required: true, message: "Falta el campo: Equipo" }]}>
                                <SelectActivoCMMS
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    disabled={this.state.sinActivo}
                                    textoInicial={t?.activoTexto}
                                />
                            </FormItem>
                            <div className="cmms-switch-linea" style={{ marginTop: 4 }}>
                                <Switch size="small" checked={this.state.sinActivo} onChange={(sinActivo) => this.setState({ sinActivo })} />
                                La solicitud no se relaciona con un equipo
                            </div>
                        </FormItem>
                        {this.state.sinActivo && (
                            <FormItem label="Cliente" name="clienteId">
                                <SelectClientesItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} width="100%" />
                            </FormItem>
                        )}
                        <Row gutter={12}>
                            <Col xs={24} md={10}>
                                <FormItem label="Tipo de solicitud" name="tipoSolicitud" required>
                                    <SelectItem placeholder="Tipo">
                                        {this.state.tiposSolicitud.map((v) => (
                                            <Option key={v} value={v}>
                                                {v}
                                            </Option>
                                        ))}
                                    </SelectItem>
                                </FormItem>
                            </Col>
                            <Col xs={24} md={14}>
                                <FormItem label="Fecha y hora de la solicitud" name="fechaSolicitud">
                                    <DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: "100%" }} />
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="Prioridad" name="prioridad" required tooltip="Urgente: atender de inmediato. Durante el día: en la jornada. Programable: se agenda.">
                            <SelectorColoresCMMS opciones={COLORES_PRIORIDAD} />
                        </FormItem>
                        <FormItem label="Solicitud" name="solicitud" required max={4000}>
                            <TextAreaItem rows={3} placeholder="¿Qué pasa con el equipo? (ej. Alarma de desviación del registrador)" />
                        </FormItem>
                        <FormItem label="Comentarios del solicitante" name="comentariosSolicitante">
                            <TextAreaItem rows={2} placeholder="Opcional" />
                        </FormItem>
                    </DynamicCardForm>

                    <DynamicCardForm title="Solicitante y atención" xs={24} lg={10}>
                        <FormItem label="Solicitante" name="solicitante" max={120}>
                            <InputItem placeholder="Nombre de quien reporta" />
                        </FormItem>
                        <Row gutter={12}>
                            <Col xs={12}>
                                <FormItem label="Teléfono" name="telefono" max={40}>
                                    <InputItem placeholder="Teléfono" />
                                </FormItem>
                            </Col>
                            <Col xs={12}>
                                <FormItem
                                    label="Correo"
                                    name="correo"
                                    max={120}
                                    tooltip={this.state.avisarSolicitante ? "Si deja su correo, se le avisa por correo de cada avance de su ticket." : undefined}
                                >
                                    <InputItem placeholder="Correo" />
                                </FormItem>
                            </Col>
                        </Row>
                        <FormItem label="Ingeniero asignado" name="empleadoAsignadoId" tooltip="Al asignar un ingeniero a un ticket Recibido pasa a Asignado.">
                            <SelectEmpleadosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} width="100%" placeholder="Ingeniero" />
                        </FormItem>
                        {this.editar && (
                            <FormItem label="Diagnóstico" name="diagnostico">
                                <TextAreaItem rows={3} placeholder="Diagnóstico inicial" />
                            </FormItem>
                        )}
                    </DynamicCardForm>

                    <DynamicCardForm title="Anexos" xs={24}>
                        <FormItem name="anexos" noStyle>
                            <AnexosCMMS />
                        </FormItem>
                    </DynamicCardForm>

                    {this.editar && this.renderSeguimiento()}
                </ModalFormCMMS>

                {this.renderModalEstatus()}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ModalTicket));
